// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"b502fa98","488":"6bbbc4b4"}[chunkId] + ".chunk.js";
};